import React, { useState } from "react";

const TemplateManagement = () => {
  const [templates, setTemplates] = useState([
    {
      id: 1,
      name: "Client Visit",
      language: "en",
      content: "Client visit scheduled",
      variables: "Client",
    },
  ]);
  const [newTemplate, setNewTemplate] = useState({
    name: "",
    language: "",
    content: "",
    variables: "",
  });
  const [message, setMessage] = useState(null);

  const handleTemplateChange = (e) => {
    const { name, value } = e.target;
    setNewTemplate({ ...newTemplate, [name]: value });
  };

  const handleAddTemplate = (e) => {
    e.preventDefault();
    if (newTemplate.name && newTemplate.language && newTemplate.content) {
      const template = { ...newTemplate, id: Date.now() };
      setTemplates([...templates, template]);
      setMessage({
        type: "success",
        text: "Template created successfully! Awaiting approval.",
      });
      setNewTemplate({ name: "", language: "", content: "", variables: "" });
    } else {
      setMessage({
        type: "error",
        text: "All fields except variables are required.",
      });
    }
  };

  const handleDeleteTemplate = (id) => {
    setTemplates(templates.filter((t) => t.id !== id));
    setMessage({ type: "success", text: "Template deleted successfully!" });
  };

  return (
    <div className="p-4 bg-white rounded shadow mb-6">
      <h3 className="text-xl font-bold text-blue-600 mb-2 text-left">
        Template Management
      </h3>

      <h4 className="font-semibold mb-2 text-left">Create New Template:</h4>
      <form onSubmit={handleAddTemplate} className="flex flex-col space-y-2">
        <input
          type="text"
          name="name"
          value={newTemplate.name}
          onChange={handleTemplateChange}
          placeholder="Template Name"
          className="p-2 border rounded"
        />
        <input
          type="text"
          name="language"
          value={newTemplate.language}
          onChange={handleTemplateChange}
          placeholder="Language (e.g., en)"
          className="p-2 border rounded"
        />
        <textarea
          name="content"
          value={newTemplate.content}
          onChange={handleTemplateChange}
          placeholder="Message Content"
          className="p-2 border rounded"
        ></textarea>
        <input
          type="text"
          name="variables"
          value={newTemplate.variables}
          onChange={handleTemplateChange}
          placeholder="Variables (optional)"
          className="p-2 border rounded"
        />
        <button type="submit" className="bg-blue-600 text-white p-2 rounded">
          Create Template
        </button>
      </form>

      {message && (
        <div
          className={`mb-4  mt-4 -p-2 rounded ${
            message.type === "success"
              ? "bg-green-100 text-green-800"
              : "bg-red-100 text-red-800"
          }`}
        >
          {message.text}
        </div>
      )}
      <h4 className="font-semibold mb-2 text-left mt-4">Existing Templates:</h4>
      <ul className="mb-4 mt-4">
        {templates.map((template) => (
          <li key={template.id} className="border p-2 rounded mb-2">
            <div className="flex justify-between">
              <div>
                <p className="text-left">
                  <strong>Name:</strong>
                  {template.name}
                </p>
                <p className="text-left">
                  <strong>Language:</strong>
                  {template.language}
                </p>
                <p className="text-left">
                  <strong>Content:</strong>
                  {template.content}
                </p>
                {template.variables && (
                  <p className="text-left">
                    <strong>Variables:</strong> {template.variables}
                  </p>
                )}
              </div>
              <button
                onClick={() => handleDeleteTemplate(template.id)}
                className="text-red-600 self-start"
              >
                Delete
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TemplateManagement;
